import { SettingService } from 'src/app/system-common/services/setting.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CompensationServiceHandler } from './compensation.service.handler';

@Injectable({
  providedIn: 'root',
})
export class CompensationService extends CompensationServiceHandler {
  // getOutputPreferences(ref_id: any) {
  //   throw new Error('Method not implemented.');
  // }
  constructor(http: HttpClient, settingService: SettingService) {
    super(http, settingService);
  }
}
